import * as React from 'react';

import { FormattedHTMLMessage, FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link, Typography } from '@coursera/cds-core';

import _t from 'i18n!nls/expression-of-interest';

type Props = {
  hasCourseraDisclaimer?: boolean;
};

const CourseraAndRecaptchaDisclaimer: React.FC<Props> = ({ hasCourseraDisclaimer, ...props }) => {
  const courseraDisclaimerMessage = _t(
    "By signing up to create an account I accept Coursera's {tosLink} and {privacyLink}."
  );
  const recaptchaDisclaimerMessage = _t(
    'This site is protected by reCAPTCHA and the Google {privacyPolicyLink} and {tosLink} apply.'
  );

  return (
    // eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2
    <Typography variant="body2" {...props}>
      {hasCourseraDisclaimer && (
        <>
          <FormattedHTMLMessage
            message={courseraDisclaimerMessage}
            tosLink={
              <Link href="/about/terms" target="_blank" rel="noopener noreferrer">
                {_t('Terms of Use')}
              </Link>
            }
            privacyLink={
              <Link
                href="/about/privacy"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={_t('Privacy Policy of Coursera')}
              >
                {_t('Privacy Policy')}
              </Link>
            }
          />
          &nbsp;
        </>
      )}

      <FormattedMessage
        message={recaptchaDisclaimerMessage}
        privacyPolicyLink={
          <Link href="https://policies.google.com/privacy" aria-label={_t('Privacy Policy of Google')}>
            {_t('Privacy Policy')}
          </Link>
        }
        tosLink={<Link href="https://policies.google.com/terms">{_t('Terms of Service')}</Link>}
      />
    </Typography>
  );
};

export default CourseraAndRecaptchaDisclaimer;
